import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=65d9466c&"
import script from "./articles.vue?vue&type=script&lang=js&"
export * from "./articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d9466c')) {
      api.createRecord('65d9466c', component.options)
    } else {
      api.reload('65d9466c', component.options)
    }
    module.hot.accept("./articles.vue?vue&type=template&id=65d9466c&", function () {
      api.rerender('65d9466c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/content-card-listing/articles.vue"
export default component.exports